import React, { Component } from 'react';


class Welcome extends Component {
  constructor(props) {
    super(props);
    
    this.goToQuestions = this.goToQuestions.bind(this);
  }

  goToQuestions() {
    this.props.next({ view: 'survey' })
  }

  render() {
    return (
        <main className="page__container label-page">
            <img className="label-page__image label-page__image--hands" src="/images/hands.png" alt="Hands" />
            <h1 className="label-page__heading">{this.props.survey.title}</h1>
            <p>{this.props.survey.message}</p>
            <button className="label-page__main-button main-button main-button--colored" onClick={this.goToQuestions}>
              <span className="main-button__label">Continuar</span>
              <svg className="main-button__icon" width={25} height={25}>
                  <use xlinkHref="/images/sprite.svg#arrow_down" />
              </svg>
            </button>
        </main>
    );
  }

}

export default Welcome;
